// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__oSD3V","title":"AfterBackImages_title__2ejm6","images":"AfterBackImages_images__1CUb-"};